export const contactHero = {
  title: 'お問い合わせ',
  titleEn: 'CONTACT',
  lead: 'ご質問・ご相談は、以下のフォームよりお気軽にお寄せください。担当者より2営業日以内にご返信いたします。',
};

export const inquiryGuides = [
  {
    icon: 'ri-file-text-line',
    title: '資料がほしい',
    titleEn: 'Brochure Request',
    description: 'コースの詳細やアカデミーの理念をまとめた資料を無料でお届けします。',
    href: '/brochure',
    linkLabel: '資料請求はこちら（無料）',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'コースを相談したい',
    titleEn: 'Course Consultation',
    description: '経験豊富なスタッフが、あなたの目標やご経験に合わせた最適なコース選びを無料でサポートします。',
    href: '/consultation',
    linkLabel: '個別相談を予約する',
  },
  {
    icon: 'ri-question-answer-line',
    title: 'よくある質問',
    titleEn: 'FAQ',
    description: '受講に関するよくあるご質問とその回答をまとめています。まずはこちらをご覧ください。',
    href: '/faq',
    linkLabel: 'よくある質問を見る',
  },
  {
    icon: 'ri-building-line',
    title: '法人研修',
    titleEn: 'Corporate Training',
    description: '企業向けの接遇・ビジネスマナー研修のご相談は、法人研修専用ページからお問い合わせください。',
    href: '/corporate',
    linkLabel: '法人研修を見る',
  },
];

export const inquiryCategories = [
  { value: 'course', label: 'コースについて' },
  { value: 'pricing', label: '料金について' },
  { value: 'admission', label: '入学について' },
  { value: 'seminar', label: '体験講座について' },
  { value: 'corporate', label: '法人研修について' },
  { value: 'other', label: 'その他' },
];

export const contactFaqs = [
  {
    question: '電話でも問い合わせできますか?',
    answer: 'はい。03-6824-4086（受付 平日10:00〜17:00）で承ります。フォーム・メールでもお気軽にどうぞ。',
  },
  {
    question: '返信までどのくらいかかりますか?',
    answer: '2営業日以内にご返信します。',
  },
  {
    question: '法人研修の相談もここでできますか?',
    answer: '可能ですが、法人研修専用ページにお問い合わせフォームをご用意していますので、そちらがスムーズです。',
  },
];

export const contactRelatedPages = [
  {
    title: 'よくある質問',
    description: '受講に関するよくあるご質問と回答',
    href: '/faq',
  },
  {
    title: '資料請求',
    description: '無料の資料をお届け',
    href: '/brochure',
  },
  {
    title: '個別相談予約',
    description: '無料・オンライン可の相談',
    href: '/consultation',
  },
  {
    title: '法人研修',
    description: '企業向けの接遇・ビジネスマナー研修',
    href: '/corporate',
  },
];